module.exports = __webpack_public_path__ + "static/Smart-Factory-1fbabb37b2e2a79f369e913ca021697b.jpg";